import {
  Card, 
  Group,
  Stack, 
  Text, 
  Badge,
  Flex,
  Box,
  Center,
} from "@mantine/core";
import { IconCalendar, IconChevronRight, IconUser, IconTarget} from "@tabler/icons-react";
import APP_STATES from "../../enums/AppStates";

const PeiCardButton = ({ pei, onOpen }) => {
  const isDraft = pei?.estado.Id.toUpperCase() === APP_STATES.BORRADOR;
  const isActive = pei?.estado.Id.toUpperCase() === APP_STATES.ACTIVO;

  return (
    <Card
      radius="md" p="sm" withBorder
      className="sp-card sp-card--hoverable"
      onClick={onOpen}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onOpen()}
    >
      <Flex
        gap="md"
        justify="flex-start"
        align="center"
        direction="row"
        wrap="nowrap"
      >
        <Stack gap={'md'} flex={1}>
          <Box>
            <Text size="lg" fw={700} >{pei?.Codigo}</Text>
            <Badge radius="xl" size="sm" color={isActive ? "#e72166" : isDraft ? "gray" : 'blue'}>
              {pei?.estado.Codigo}
            </Badge>
          </Box>

          <Group gap={'xl'}>
            <Box>
              <Text size="sm" c="dimmed">Cantidad de Objetivos</Text>
              <Center inline>
                <IconTarget size={15}/>
                <Text size="md" ml={5}>{pei.Objetivos.length ?? 0} Objetivos</Text>
              </Center>
            </Box>
            <Box>
              <Text size="sm" c="dimmed">Usuario actualizacion</Text>
              <Center inline>
                <IconUser size={15}/>
                <Text size="md" ml={5}>{pei?.vc_luuser ? pei.vc_luuser : '[No especificado]'}</Text>
              </Center>
            </Box>
            <Box>
              <Text size="sm" c="dimmed">Fecha actualizacion</Text>
              <Center inline>
                <IconCalendar size={15}/>
                <Text size="md" ml={5}>{pei?.dt_lu}</Text>
              </Center>
            </Box>
          </Group>
        </Stack>

        <Group gap={6} align="start">
          <IconChevronRight size={18} />
        </Group>
      </Flex>
    </Card>
  );
}

export default PeiCardButton;